export const templates = [
  { id: 1, name: "Template 1", bgColor: "#FFCDD2", background: "https://i.ibb.co/yQFb58z/slidebg1.webp" },
  { id: 2, name: "Template 2", bgColor: "#C8E6C9", background: "https://i.ibb.co/gt3dVdb/slidebg2.webp" }, 
  { id: 3, name: "Template 3", bgColor: "#BBDEFB", background: "https://i.ibb.co/mRfR5qC/slidebg3.webp" },
  { id: 4, name: "Template 4", bgColor: "#E1BEE7", background: "https://i.ibb.co/26xCCKd/slide4.jpg" },
  { id: 5, name: "Template 5", bgColor: "#FFE0B2", background: "https://i.ibb.co/zx39wXk/slide6.jpg" }
];
 

export const FIRST_SLIDE_MASTER_BG = 'https://i.ibb.co/Y7dhqZhM/pptmaster.png';
 
export const sasToken =
"sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-06-04T13:26:22Z&st=2024-11-05T05:26:22Z&spr=https,http&sig=pAcLQDyT%2BRNtUABOSobtIhb%2FuSA43rbiU0btYf%2FVttw%3D";
export const containerName = `cmpptgencontainerv1`;
export const storageAccountName = "codemonkpptgen";


export const MAX_TITLE_LENGTH = 25;
// export const sasToken =
// "sp=r&st=2025-01-23T07:28:32Z&se=2025-03-23T15:28:32Z&spr=https&sv=2022-11-02&sr=c&sig=QZDNech4dgZwW%2Bq4%2FR4k%2FTBGJxOIVOyj1Ys%2F%2Bjy45c4%3D";
// export const containerName = `test`;
// export const storageAccountName = "testingfeatures";

export const API_URL = "https://et-genai-azureopenai1-q.openai.azure.com/openai/deployments/gpt-4o_2024-08-06/chat/completions?api-version=2024-02-15-preview";
export  const API_KEY = "2dfa39fbfb5746fc92589d6bd63b99a9";



// export const PPT2IMG_BACKEND_URL = "https://dev.api.ppt.codemonk.in/convert-pptx";
export const PPT2IMG_BACKEND_URL = "http://localhost:3001/convert-pptx";
